import { ACCOUNT } from '../constants'
import {
  EditShipperCompanyData,
  type ICompanyLiteData,
  type IEditUser,
  type IEditUserResponse,
  type IRegisterUserData,
} from '../types'
import { useUpFetch } from '../utils'

export const useEditUserApi = () => {
  const upFetch = useUpFetch()

  const editUserShipper = async (data: IEditUser) => {
    const res = await upFetch<{ data: IEditUserResponse }>(`/users/shipper/${data.id}`, {
      body: data,
      method: 'PATCH',
    })

    return res.data
  }

  const editCompany = async (data: EditShipperCompanyData, companyId: number) => {
    const { account, country, profile, ...companyDataWithoutAccount } = data

    await upFetch(`/companies/shippers/${companyId}`, {
      body: {
        ...companyDataWithoutAccount,
        country: country?.code || '',
        profile: {
          ...profile,
          source: process.env.NEXT_PUBLIC_SOURCE,
          type: profile?.type?.alias,
        },
      },
      method: 'PATCH',
    })

    const response = await upFetch(`/companies/${companyId}/${ACCOUNT}`, {
      body: account,
      method: 'PATCH',
    })

    return response.data as IRegisterUserData
  }

  const createCompany = async (data: Partial<Omit<ICompanyLiteData, 'account'>>) => {
    const response = await upFetch<{ data: ICompanyLiteData }>(`/companies/shippers`, {
      body: {
        ...data,
        country: data.country?.code,
        source: 'kcharles', // This is only temporary
      },
      method: 'POST',
    })
    return response.data
  }

  return {
    createCompany,
    editCompany,
    editUserShipper,
  }
}
